import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import layoutReducer from "./layoutSlice";
import authReducer from "./authSlice";
import funeralReducer from "./funeralSlice";
import attendeeReducer from "./attendeeSlice";
import hallReducer from "./hallSlice";
import { sentryReduxEnhancer } from "./sentryReduxEnhancer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  funeral: funeralReducer,
  attendee: attendeeReducer,
  hall: hallReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export const persistor = persistStore(store);
